import { useMutation } from '@provision/graphql-client';
import { useCallback } from 'react';
import { UPDATE_CONVERSATION_ASSIGNEE_GROUP_MUTATION } from 'src/graphql/entities/conversation-assignee-group/conversation-assignee-group.operations';
import type {
  ConversationAssigneeGroupManagement,
  UpdateConversationAssigneeGroupInput,
  UpdateConversationAssigneeGroupResponse,
} from 'src/graphql/entities/conversation-assignee-group/conversation-assignee-group.types';

export const useUpdateConversationAssigneeGroup = () => {
  const [mutate, { loading }] = useMutation<UpdateConversationAssigneeGroupResponse>(
    UPDATE_CONVERSATION_ASSIGNEE_GROUP_MUTATION,
  );

  const updateWithOptimisticResponse = useCallback(
    (
      input: UpdateConversationAssigneeGroupInput,
      base: ConversationAssigneeGroupManagement,
    ) => {
      return mutate({
        variables: input,
        optimisticResponse: {
          updateConversationAssigneeGroup: [
            {
              __typename: 'ConversationAssigneeGroup',
              ...base,
              ...(input.name !== undefined ? { name: input.name } : {}),
              ...(input.description !== undefined ? { description: input.description } : {}),
              ...(input.icon !== undefined ? { icon: input.icon } : {}),
            },
          ],
        },
      });
    },
    [mutate],
  );

  return {
    updateConversationAssigneeGroup: updateWithOptimisticResponse,
    loading,
  };
};
